
import { Options, Vue } from "vue-class-component";
import DocumentsPanel from "@/components/middle-office/tabs/documents/DocumentsPanel.vue";
import { formatDate } from "@/utils/configuration/formatters-config";
import { globalConfig } from "@/utils";
import moment from "moment";

@Options({
  components: { DocumentsPanel },
  props: ["histories"],
})
export default class HistoriesPanel extends Vue {
  histories?: [];

  columns = globalConfig.table_config.middleOfficeTable.histories;

  get displayedHistories(): any[] {
    const rows = Array.isArray(this.histories) ? [...(this.histories as any[])] : [];
    if (rows.length === 0) return rows;

    const paymentIndex = rows.findIndex(
      (row: any) => row?.status?.resourceUid === "PAYMENT"
    );
    if (paymentIndex <= 0) return rows;
    let latestIndex = 0;
    rows.forEach((row: any, index: number) => {
      const latestDate = rows[latestIndex]?.creationDate;
      if (!row?.creationDate) return;
      if (!latestDate || moment(row.creationDate).isAfter(moment(latestDate))) {
        latestIndex = index;
      }
    });
    const paymentRow = rows[paymentIndex];
    const latestRow = rows[latestIndex];
    const mockedPaymentRow = {
      ...paymentRow,
      creationDate: latestRow?.creationDate ?? paymentRow.creationDate,
      creationUser: latestRow?.creationUser ?? paymentRow.creationUser,
    };
    rows[latestIndex] = {
      ...latestRow,
      creationDate: paymentRow.creationDate,
      creationUser: paymentRow.creationUser,
    };

    rows.splice(paymentIndex, 1);
    rows.unshift(mockedPaymentRow);

    return rows;
  }
}
